type ViewBridgeMessage = { type: 'elowen-view-action'; value: string } | { type: 'elowen-view-height'; height: number };

/** Also embedded verbatim in the trusted iframe shell. No closure dependencies. */
export function parseViewBridgeMessage(value: unknown): ViewBridgeMessage | undefined {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) return undefined;
  const item = value as Record<string, unknown>;
  const keys = Object.keys(item);
  if (keys.length !== 2 || !keys.includes('type')) return undefined;
  if (item.type === 'elowen-view-action' && keys.includes('value') && typeof item.value === 'string'
    && item.value.trim().length > 0 && new TextEncoder().encode(item.value).byteLength <= 4096) {
    return { type: item.type, value: item.value };
  }
  if (item.type === 'elowen-view-height' && keys.includes('height') && typeof item.height === 'number'
    && Number.isFinite(item.height) && item.height >= 1 && item.height <= 10000) {
    return { type: item.type, height: item.height };
  }
  return undefined;
}
